import { Controller } from "@hotwired/stimulus"
import consumer from "../channels/consumer"

/**
 * Notification badge controller.
 *
 * Simple controller that just updates the badge count.
 * Used on mobile where clicking the bell goes to the notifications page.
 *
 * @example HTML
 *   <a data-controller="notification-badge"
 *      data-notification-badge-url-value="/notifications/unread_count.json">
 *     <span data-notification-badge-target="badge">3</span>
 *   </a>
 */
export default class extends Controller {
  static targets = ["badge"]

  /**
   * Called when controller connects to the DOM.
   * Sets up Action Cable subscription for real-time updates.
   */
  connect() {
    // Subscribe to notifications channel for real-time badge updates
    this.subscription = consumer.subscriptions.create("NotificationsChannel", {
      received: (data) => this.handleNotification(data)
    })
  }

  /**
   * Called when controller disconnects from the DOM.
   * Cleans up subscription.
   */
  disconnect() {
    if (this.subscription) {
      this.subscription.unsubscribe()
    }
  }

  /**
   * Handles a real-time notification received via Action Cable.
   *
   * @param {Object} data - The notification data
   */
  handleNotification(data) {
    if (data.unread_count !== undefined) {
      this.updateBadge(data.unread_count)
    }
  }

  /**
   * Updates the badge with the unread count.
   *
   * @param {number} count - The unread count
   */
  updateBadge(count) {
    if (!this.hasBadgeTarget) return

    if (count > 0) {
      this.badgeTarget.textContent = count > 99 ? "99+" : count
      this.badgeTarget.classList.remove("hidden")
    } else {
      this.badgeTarget.classList.add("hidden")
    }
  }
}

